import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import {
  ClearRequestInterceptor,
  COMPANY_HEADER_CONFIG,
  CompanyHeaderInterceptor,
  CORE_REGISTRY_CONFIG,
  CoreRegistryInterceptor,
  WithCredentialsInterceptor,
  XsrfInterceptor,
} from '@celerofinancas/ui-interceptors';
import { httpHeadersInterceptor } from '@celerofinancas/ui-oauth';
import { checkingAccountsOrderInterceptor } from '@shared/interceptors/checking-accounts-order.interceptor';
import { createCoreRegistryConfig } from '@shared/interceptors/core-registry-config.factory';
import { savingsAccountNicknameInterceptor } from '@shared/interceptors/savings-account-nickname.interceptor';
import { TokenRaceConditionInterceptor } from '@shared/interceptors/token-race.interceptor';
import { TokenRefreshInterceptor } from '@shared/interceptors/token-refresh.interceptor';

/**
 * Interceptors list for the application.
 */
export const INTERCEPTORS_LIST = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenRefreshInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenRaceConditionInterceptor,
    multi: true,
  },
  provideHttpClient(
    withInterceptorsFromDi(),
    withInterceptors([
      httpHeadersInterceptor,
      savingsAccountNicknameInterceptor,
      checkingAccountsOrderInterceptor,
    ])
  ),
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WithCredentialsInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: XsrfInterceptor,
    multi: true,
  },
  {
    provide: CORE_REGISTRY_CONFIG,
    useFactory: createCoreRegistryConfig,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: CoreRegistryInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ClearRequestInterceptor,
    multi: true,
  },
  {
    // Matches the core registry authWhiteList, which also skips the OpenID discovery
    provide: COMPANY_HEADER_CONFIG,
    useValue: { excludedPaths: ['openid-configuration'] },
  },
  {
    // Sends `x-company-id` (RFC 0014). After CoreRegistryInterceptor, which fills a missing
    // company_pk, and ClearRequestInterceptor, so the header matches what is sent.
    provide: HTTP_INTERCEPTORS,
    useClass: CompanyHeaderInterceptor,
    multi: true,
  },
];
